import Head from 'next/head';

import {HeadSEO} from '@udemy/head-seo';
import {useI18n} from '@udemy/i18n';

import {getLayout} from 'src/components/layout';
import {useSetupNavigation} from 'src/hooks/use-setup-navigation';
import {useCanonicalUrl} from 'src/hooks/useCanonicalUrl';
import {META_DEFAULT_BASE_URL} from 'src/lib/constants';
import {PageProps} from 'src/types/page-props';
import FreeCategory from 'udemy-django-static/js/category/free/udlite/free-category.react-isocomponent';

import {FreeCategoryProps} from './types';

export type FreeCategoryPageProps = FreeCategoryProps & PageProps;

export const FreeCategoryPage = (props: FreeCategoryPageProps) => {
    const {gettext, interpolate} = useI18n();
    const {url: canonicalUrl} = useCanonicalUrl(['p'], META_DEFAULT_BASE_URL);
    useSetupNavigation();

    const title = interpolate(
        gettext('%(resourceType)s Resource Center: Find Free Online Courses'),
        {
            resourceType: props.pageObject.title_cleaned === 'vodafone' ? 'Vodafone' : 'Udemy Free',
        },
        true,
    );
    const description = gettext(
        'Free courses from Udemy to help you make the most of your time, from working at home to trending technical skills and self-improvement, wherever you are.',
    );

    return (
        <>
            <HeadSEO
                title={`${title} | Udemy`}
                ogTitle={title}
                description={description}
                ogDescription={description}
                ogType="video_lecture"
                ogLocale={process.env.I18N_PATH_TO_BUNDLE_MAP[props.locale]}
                canonicalUrl={canonicalUrl}
                assetPath={process.env.ASSET_PREFIX}
                headWrapper={Head}
            />
            <FreeCategory {...props} />
        </>
    );
};

FreeCategoryPage.getLayout = getLayout;
